import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { text } from '@guardian/source-foundations';
import { Zero } from './numbers/Zero';
import { One } from './numbers/One';
import { Two } from './numbers/Two';
import { Three } from './numbers/Three';
import { Four } from './numbers/Four';
import { Five } from './numbers/Five';
import { Six } from './numbers/Six';
import { Seven } from './numbers/Seven';
import { Eight } from './numbers/Eight';
import { Nine } from './numbers/Nine';
import { Ten } from './numbers/Ten';
export const Score = ({ score }) => {
    const ScoreStyles = ({ children }) => (_jsx("div", Object.assign({ css: css `
				position: relative;
				width: 3.75rem;
				height: 3.75rem;
				border-radius: 1.875rem;
				border: 0.0625rem solid ${text.primary};

				svg {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					margin: auto;
				}
			` }, { children: children }), void 0));
    switch (score) {
        case 0:
            return (_jsx(ScoreStyles, { children: _jsx(Zero, {}, void 0) }, void 0));
        case 1:
            return (_jsx(ScoreStyles, { children: _jsx(One, {}, void 0) }, void 0));
        case 2:
            return (_jsx(ScoreStyles, { children: _jsx(Two, {}, void 0) }, void 0));
        case 3:
            return (_jsx(ScoreStyles, { children: _jsx(Three, {}, void 0) }, void 0));
        case 4:
            return (_jsx(ScoreStyles, { children: _jsx(Four, {}, void 0) }, void 0));
        case 5:
            return (_jsx(ScoreStyles, { children: _jsx(Five, {}, void 0) }, void 0));
        case 6:
            return (_jsx(ScoreStyles, { children: _jsx(Six, {}, void 0) }, void 0));
        case 7:
            return (_jsx(ScoreStyles, { children: _jsx(Seven, {}, void 0) }, void 0));
        case 8:
            return (_jsx(ScoreStyles, { children: _jsx(Eight, {}, void 0) }, void 0));
        case 9:
            return (_jsx(ScoreStyles, { children: _jsx(Nine, {}, void 0) }, void 0));
        case 10:
        default:
            return (_jsx(ScoreStyles, { children: _jsx(Ten, {}, void 0) }, void 0));
    }
};
